"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSrmPriceChangedEventTopic = exports.isSrmGridPriceChangedPushEvent = exports.getToteRaceEventTopic = exports.isToteRacePushEvent = exports.isPayIdStatusChangedPushEvent = exports.isFobMarketSettlementPushEvent = exports.isAccountBalanceChangedExceptionPushEvent = exports.isAccountBalanceChangedPushEvent = exports.isToteRaceAbandonedPushEvent = exports.isToteRaceResultsDelayedPushEvent = exports.isToteRacePoolCompletedPushEvent = exports.isToteRaceStatusChangedPushEvent = exports.isToteAcceptorUnscratchedPushEvent = exports.isToteAcceptorScratchedPushEvent = exports.isTotePriceChangedPushEvent = exports.isSportsPriceChangedPushEvent = exports.isFobPriceChangedPushEvent = void 0;
const isFobPriceChangedPushEvent = (payload) => {
    return payload && payload.eventType === 'FobPriceChanged';
};
exports.isFobPriceChangedPushEvent = isFobPriceChangedPushEvent;
const isSportsPriceChangedPushEvent = (payload) => {
    return payload && payload.eventType === 'SportsPriceChanged';
};
exports.isSportsPriceChangedPushEvent = isSportsPriceChangedPushEvent;
const isTotePriceChangedPushEvent = (payload) => {
    return payload && payload.eventType === 'TotePriceChanged';
};
exports.isTotePriceChangedPushEvent = isTotePriceChangedPushEvent;
const isToteAcceptorScratchedPushEvent = (payload) => {
    return payload && payload.eventType === 'ToteAcceptorScratched';
};
exports.isToteAcceptorScratchedPushEvent = isToteAcceptorScratchedPushEvent;
const isToteAcceptorUnscratchedPushEvent = (payload) => {
    return payload && payload.eventType === 'ToteAcceptorUnscratched';
};
exports.isToteAcceptorUnscratchedPushEvent = isToteAcceptorUnscratchedPushEvent;
function isToteRaceStatusChangedPushEvent(payload) {
    return payload && payload.eventType === 'ToteRaceStatusChanged';
}
exports.isToteRaceStatusChangedPushEvent = isToteRaceStatusChangedPushEvent;
function isToteRacePoolCompletedPushEvent(payload) {
    return payload && payload.eventType === 'ToteRacePoolCompleted';
}
exports.isToteRacePoolCompletedPushEvent = isToteRacePoolCompletedPushEvent;
function isToteRaceResultsDelayedPushEvent(payload) {
    return payload && payload.eventType === 'ToteRaceResultsDelayChanged';
}
exports.isToteRaceResultsDelayedPushEvent = isToteRaceResultsDelayedPushEvent;
function isToteRaceAbandonedPushEvent(payload) {
    return payload && payload.eventType === 'ToteRaceAbandonChanged';
}
exports.isToteRaceAbandonedPushEvent = isToteRaceAbandonedPushEvent;
function isAccountBalanceChangedPushEvent(payload) {
    return payload && payload.eventType === 'AccountBalanceChanged';
}
exports.isAccountBalanceChangedPushEvent = isAccountBalanceChangedPushEvent;
function isAccountBalanceChangedExceptionPushEvent(payload) {
    return payload && payload.eventType === 'AccountBalanceChangedException';
}
exports.isAccountBalanceChangedExceptionPushEvent = isAccountBalanceChangedExceptionPushEvent;
function isFobMarketSettlementPushEvent(payload) {
    return payload && payload.eventType === 'FobMarketSettlement';
}
exports.isFobMarketSettlementPushEvent = isFobMarketSettlementPushEvent;
function isPayIdStatusChangedPushEvent(payload) {
    return payload && payload.eventType === 'PayIdStatusChanged';
}
exports.isPayIdStatusChangedPushEvent = isPayIdStatusChangedPushEvent;
function isToteRacePushEvent(payload) {
    return payload && payload.eventType === 'ToteRaceEvent';
}
exports.isToteRacePushEvent = isToteRacePushEvent;
function getToteRaceEventTopic(raceId) {
    return `tabtouch/tote/race/${raceId}/event`;
}
exports.getToteRaceEventTopic = getToteRaceEventTopic;
function isSrmGridPriceChangedPushEvent(payload) {
    return payload && payload.eventType === 'SrmGridPriceChanged';
}
exports.isSrmGridPriceChangedPushEvent = isSrmGridPriceChangedPushEvent;
function getSrmPriceChangedEventTopic(fixtureDate, fixtureId, raceNumber) {
    return `tabtouch/fob/srm/price-changed/${fixtureDate}/${fixtureId}/${raceNumber}`;
}
exports.getSrmPriceChangedEventTopic = getSrmPriceChangedEventTopic;
